import React from "react";
import { Card } from "@/components/ui/card";
import { companyInfo } from "@/mock/zebraCarsMock";

export const AboutSection = () => {
  return (
    <section id="o-nama" className="space-96 py-24 !bg-[#303030]">
      <div className="container max-w-[87.5rem] mx-auto px-5 lg:px-10 flex flex-col lg:flex-row gap-12 items-start">
        <div className="flex-1 space-y-4">
          <p className="caption text-[var(--text-secondary)]">O NAMA</p>
          <h2 className="heading-2 !mt-[100px] !mb-[16px] text-[var(--text-primary)]">
            Pouzdan partner za vašu registraciju od 2009. godine
          </h2>
          <p className="body-medium max-w-[48ch] !opacity-[0%] text-[var(--text-primary)]">
            {companyInfo.description} Naš cilj je da ceo proces registracije i tehničkog pregleda obavite na
            jednom mestu – brzo, korektno i bez nervoze.
          </p>
          <p className="body-big max-w-[100ch] !text-lg !text-center !pb-[100px] text-[var(--text-secondary)]">
            Fokus nam je na pouzdanosti, tačnosti i transparentnoj komunikaciji. Stotine zadovoljnih vozača iz
            Novog Sada i okoline nam svake godine ponovo ukazuju poverenje.
          </p>
        </div>

        <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Card className="team-card bg-[var(--bg-card)] border-[var(--border-light)] text-[var(--text-primary)]">
            <div className="team-card-image overflow-hidden">
              <img
                src={require("@/assets/viber_image_2026-02-02_21-16-55-128.jpg")}
                alt="Čekaonica Zebra Cars"
                className="w-full h-full object-cover" />

            </div>
            <div className="team-card-content">
              <h3 className="heading-5 mb-2 text-[var(--text-primary)]">Prijatan prostor za čekanje</h3>
              <p className="body-small">
                Dok završavamo vašu registraciju ili tehnički pregled, možete se opustiti u udobnoj čekaonici uz
                kafu i prijatnu atmosferu.
              </p>
            </div>
          </Card>

          <Card className="team-card bg-[var(--bg-card)] border-[var(--border-light)] text-[var(--text-primary)] flex flex-col justify-between">
            <div className="team-card-content">
              <h3 className="heading-5 mb-2 text-[var(--text-primary)]">Zašto Zebra Cars?</h3>
              <ul className="list-disc list-inside body-small space-y-2">
                <li>Preko decenije iskustva u registraciji vozila</li>
                <li>Brz i efikasan tehnički pregled</li>
                <li>Transparentne cene i jasna objašnjenja</li>
                <li>Prijateljski pristup svakom klijentu</li>
              </ul>
            </div>
          </Card>
        </div>
      </div>
    </section>);

};

export default AboutSection;